module.exports = __webpack_public_path__ + "img/avatar0.644be731.png";